import { useContext } from "react";

import Context from "../context";

export const useGetUnknownQueryKey = () => {
	const { state } = useContext(Context);

	const key = ["adminUnknownSecurities", state.filterName, state.filterExchange, state.filterType];

	return key;
};
